import { CrownIcon } from '@/components/atoms/icons';
import { Accordion, OwnerItem } from '@/components/molecules';
import { useTranslation } from '@/core/hooks';
import React from 'react';
import { StyleSheet, View } from 'react-native';

export interface OwnerDetails {
    id: string;
    name: string;
    share: number;
    isPrimary?: boolean;
}

export interface PropertyOwnerDetailsAccordionProps {
    owners: OwnerDetails[];
}

export function PropertyOwnerDetailsAccordion({ owners }: PropertyOwnerDetailsAccordionProps) {
    const { t } = useTranslation();

    return (
        <Accordion
            icon={CrownIcon}
            title={t('propertyDetails.ownerDetails')}
            contentPadding={16}
            defaultExpanded={false}
        >
            <View style={styles.ownersList}>
                {owners.map((owner) => (
                    <OwnerItem
                        key={owner.id}
                        id={owner.id}
                        name={owner.name}
                        share={owner.share}
                        isPrimary={owner.isPrimary ?? false}
                    />
                ))}
            </View>
        </Accordion>
    );
}

const styles = StyleSheet.create({
    ownersList: {
        gap: 8,
    },
});

export default PropertyOwnerDetailsAccordion;
